import { AppState } from 'src/application/state';
import { initialState, SecExtraShortData } from './reducer';

export const getSecExtraShortIsModuleLoaded = (
  state: AppState,
): boolean => (
  state.secExtraShort
    ? state.secExtraShort.isModuleLoaded
    : initialState.isModuleLoaded
);

export const getSecExtraShortData = (
  state: AppState,
): SecExtraShortData => (
  state.secExtraShort
    ? state.secExtraShort
    : initialState
);
